import * as React from "react";

export const places = [
  {
    image: "/img/Stay-Carneros.jpg",
    name: "Carneros Resort and Spa",
    url: "http://www.carnerosresort.com/",
    body: <>
      4048 Sonoma Highway<br/>
      Napa, California 94559<br/>
      <em>Bowers-Wong wedding rate</em>
    </>
  },
  {
    image: "/img/Stay-Andaz.jpg",
    name: "Andaz",
    url: "https://napa.andaz.hyatt.com/en/hotel/home.html",
    body: <>
    1450 First Street<br/>
    Napa, California 94559
    </>
  },
  {
    image: "/img/Stay-Archer.jpg",
    name: "Archer Hotel",
    url: "https://archerhotel.com/napa",
    body: <>
    1230 First Street<br/>
    Napa, California 94559
    </>
  },
  {
    image: "/img/Stay-WestinVerasaNapa.jpg",
    name: "The Westin Verasa Napa",
    url: "http://www.westinnapa.com/",
    body: <>
    1314 McKinstry Street<br/>
    Napa, California 94559
    </>
  },
  {
    image: "/img/Stay-Senza.jpg",
    name: "Senza",
    url: "http://www.senzahotel.com/",
    body: <>
    4066 Howard Lane<br/>
    Napa, California 94558
    </>
  },
  {
    image: "/img/Stay-Hilton.jpg",
    name: "Hilton Garden Inn Napa",
    url: "http://www.napahiltongardeninn.com/",
    body: <>
    3585 Solano Avenue<br/>
    Napa, California 94558
    </>
  },
  {
    image: "/img/Stay-Marriot.jpg",
    name: "Napa Valley Marriott",
    url: "http://www.napavalleymarriott.com/",
    body: <>
    3425 Solano Avenue<br/>
    Napa, California 94558
    </>
  },
  {
    image: "/img/Stay-SpringhillSuites.jpg",
    name: "SpringHill Suites Napa Valley",
    url: "http://www.marriott.com/hotels/travel/sfons-springhill-suites-napa-valley/",
    body: <>
    (by Marriott)<br/>
    101 Gateway Road East<br/>
    Napa, California 94558
    </>
  },
  {
    image: "/img/Stay-EmbassySuites.jpg",
    name: "Napa Valley Embassy Suites",
    url: "http://embassysuites3.hilton.com/en/index.html",
    body: <>
    (by Hilton)<br/>
    1075 California Boulevard<br/>
    Napa, California 94559
    </>
  },
  {
    image: "/img/Stay-NapaWineryInn.jpg",
    name: "Napa Winery Inn",
    url: "http://www.napawineryinn.com/",
    body: <>
    1998 Trower Avenue<br/>
    Napa, California 94558
    </>
  },
  {
    image: "/img/Stay-AirBnB.jpg",
    name: "AirBnB",
    url: "https://www.airbnb.com/",
    body: <>
    </>
  },
  {
    image: "/img/Stay-VRBO.jpg",
    name: "VRBO",
    url: "https://www.vrbo.com/",
    body: <>
    </>
  },
];


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/whereToStay/places.tsx